import { JsonElementType, JsonObject, JsonProperty } from "ta-json";

import type CultureInfo from "../../culture-info";
import { FieldFilterRequestResource } from "./field-filter-request-resource";

export interface IAllFacetsRequest {
    facetField: string;
    componentId?: number;
    culture: CultureInfo;
    takeUserSettings: boolean;
}

@JsonObject()
export class AllFacetsRequest implements IAllFacetsRequest {
    @JsonProperty("facetField")
    facetField: string;

    @JsonProperty("query")
    query?: string;

    @JsonProperty("searchConfigurationName")
    searchConfigurationName?: string;

    @JsonProperty("culture")
    culture: CultureInfo = "Invariant";

    @JsonProperty("take_user_settings")
    takeUserSettings: boolean;

    @JsonProperty("component")
    componentId?: number;

    @JsonProperty("l10n")
    l10n?: boolean;

    @JsonProperty("filters")
    @JsonElementType(FieldFilterRequestResource)
    filters?: Array<FieldFilterRequestResource> = [];

    constructor(init?: Partial<AllFacetsRequest>) {
        Object.assign(this, init);
    }
}
